import { render, staticRenderFns } from "./MassMemoryDls.vue?vue&type=template&id=ffc97262&scoped=true"
import script from "./MassMemoryDls.vue?vue&type=script&lang=js"
export * from "./MassMemoryDls.vue?vue&type=script&lang=js"
import style0 from "./MassMemoryDls.vue?vue&type=style&index=0&id=ffc97262&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffc97262",
  null
  
)

export default component.exports